<div class="form-group">
  <label *ngIf="label" [attr.for]="inputId">
    <span>{{ label }}</span>
    <span *ngIf="require" class="text-danger" aria-hidden="true">*</span>
  </label>
  <input #child #field="ngModel" [id]="inputId" [type]="type" [min]="min" [max]="max" class="form-control shadow-none"
    [readOnly]="readonly" [(ngModel)]="inputValue" [placeholder]="placeholder ? placeholder : label"
    [disabled]="disable" [required]="require" [pattern]="pattern"
    [attr.aria-required]="require ? 'true' : null"
    [attr.aria-invalid]="errorShown ? 'true' : null"
    [attr.aria-describedby]="describedByIds"
    (blur)="errorState.schedule()" />
  <div *ngIf="helperText" [id]="helperId" class="form-text uc-helper-text">{{ helperText }}</div>
  <div item-alert aria-live="polite">
    <div *ngIf="errorShown" [id]="errorId" role="alert" class="form-errors text-danger  my-1 py-1">
      <div *ngIf="field.errors?.required">{{ 'validation.required' | translate }}</div>
      <div *ngIf="field.errors?.pattern">{{ patternError? patternError : 'validation.pattern' | translate }}</div>
      <div *ngIf="field.errors?.rangeLength">{{ 'validation.text' | translate }} {{ child.min }}</div>
    </div>
  </div>
</div>
